import React from "react";
import { toPascalCase, uniqueId } from "../../../utility/common-methods";
import { FILTER_NAMES } from "../../../constants/app-constant";
import { AddIcon, RemoveIcon } from "../../Icons/icons.component";
export default function SocialFilterItem({
  identity,
  options = [],
  filterKey,
  filterSetter,
  filterName,
  multiselect,
  defaultValue = "",
  disabled,
  setSelectedFilter,
  selectedFilter,
  showNone = true,
  showSelectedAll = true,
  isTags = false,
}) {
  const handleChange = (e) => {
    let val = "";
    try {
      if (
        filterName === FILTER_NAMES.CITY ||
        filterName === FILTER_NAMES.TONALITY ||
        filterName === "LANGUAGE" ||
        filterName === "COUNTRY"
      ) {
        val = e.target.value;
      } else {
        val = parseInt(e.target.value, 10) || "";
      }
    } catch (e) {
      val = "";
    }
    filterSetter(val);
  };

  const isFilterPopulated = () => {
    return filterKey && !!filterKey.length;
  };
  const isSelected = () => {
    return selectedFilter == filterName;
  };

  const isDDOptionSelected = (value) => {
    return filterKey == value;
  };

  const handleFilterSelect = (value, resetAll, selectAll) => {
    try {
      if (selectAll) {
        const allTopicIds =
          options && options.map(({ id, name }) => (isTags ? name : id));
        filterSetter(allTopicIds);
        return;
      }
      if (resetAll) {
        filterSetter([]);
        return;
      }
      const tempEntity = Array.isArray(filterKey) ? [...filterKey] : [];
      const elmIndex = tempEntity.indexOf(value);
      if (elmIndex === -1) {
        tempEntity.push(value);
        filterSetter(tempEntity);
      } else {
        tempEntity.splice(elmIndex, 1);
        filterSetter(tempEntity);
      }
    } catch (e) {
      console.log("Error changing filter", filterName, e);
    }
  };

  const isSelectedAllChecked = () => {
    try {
      return filterKey.length === options.length;
    } catch (e) {
      return false;
    }
  };

  const handleSelectedAllClick = () => {
    handleFilterSelect("", isSelectedAllChecked(), !isSelectedAllChecked());
  };

  const isChecked = (type) => {
    try {
      if (filterKey) {
        if (Array.isArray(filterKey)) {
          return filterKey.indexOf(type) !== -1;
        } else {
          return filterKey == type;
        }
      }
      return false;
    } catch (e) {
      return false;
    }
  };

  if (!multiselect) {
    return (
      <div key={identity} className="form-group">
        <div className="filterDiv filteInputText">
          <label>{toPascalCase(filterName)}</label>
          <select
            filterName={filterName}
            className="form-control"
            id={identity || filterName}
            onChange={handleChange}
          >
            <option
              selected={isDDOptionSelected(defaultValue)}
              value={defaultValue}
            >
              All
            </option>
            {Array.isArray(options) &&
              options.map((el) => {
                const faceLabel = el.label || el.value || el;
                const faceValue = el.value || el.label || el;
                return (
                  <option
                    selected={isDDOptionSelected(faceValue)}
                    value={faceValue}
                  >
                    {faceLabel == "Informative" ? "Neutral" : faceLabel}
                  </option>
                );
              })}
          </select>
        </div>
      </div>
    );
  }
  const isSelectedAll = isSelectedAllChecked();
  return (
    <React.Fragment key={filterName}>
      <div className={`form-group ${disabled ? "disabled" : ""}`}>
        <div className="filterDiv accordionDropdown">
          <div
            className="filterLabel"
            onClick={() =>
              setSelectedFilter(isSelected() ? undefined : filterName)
            }
          >
            <span>{toPascalCase(filterName)}</span>
            {isSelected() ? (
              <i className="icon">
                <RemoveIcon />
              </i>
            ) : (
              <i className="icon">
                <AddIcon />
              </i>
            )}
          </div>
          <ul
            filterName={filterName}
            className={`${"filtersDropDown"}${filterName}Filter ${
              isSelected() ? "show" : "hide"
            }`}
          >
            {isFilterPopulated() && showNone && (
              <li
                onClick={() => handleFilterSelect(filterName, "", true)}
                className="reset-text"
              >
                None
              </li>
            )}
            {showSelectedAll && (
              <li
                onClick={() => handleSelectedAllClick()}
                className="filterOption"
                key={`s-all-${isSelectedAll}`}
              >
                <label className="inputWrap">
                  Select All
                  <input type="checkbox" checked={isSelectedAll} />
                  <span className="checkmark"></span>
                </label>
              </li>
            )}
            {options &&
              options.map(({ id, name, label, text, tone }, index) => {
                const faceValue = name || label || text || tone;
                const uid = uniqueId(id, faceValue) + index;
                const isElementSelected = isChecked(!isTags ? id : name);
                return (
                  <li
                    onClick={(e) => {
                      e.stopPropagation();
                      handleFilterSelect(!isTags ? id : name, "", "", "single");
                    }}
                    key={`${uid}-${isElementSelected}`}
                    className="filterOption"
                  >
                    <label className="inputWrap">
                      {faceValue == "Informative" ? "Neutral" : faceValue}
                      {<input type="checkbox" checked={isElementSelected} />}
                      <span className="checkmark"></span>
                    </label>
                  </li>
                );
              })}
          </ul>
        </div>
      </div>
    </React.Fragment>
  );
}

SocialFilterItem.defaultProps = {
  setSelectedFilter: () => {},
};
